import React,{ useState, useEffect } from 'react'
import Dialog from '../../../lib/Dialog'
import general from '../../../general'
import useActiveState from '../../../lib/useActiveState'
import Image from '../../../lib/Image'
import {Link} from "react-router-dom";
import './css/ExtendGame.css'
import Subtitle from '../../components/Subtitle'
import FreeEdition from '../../components/FreeEdition'
import GameTags from '../../components/game/GameTags'
import GameInfo from '../../components/Home/GameInfo'

export default function ExtendGame(props) {

  const [list,setList] = useState([])
  const [title,setTitle] = useState()
  const [randomColorInfo] = useActiveState('randomColorInfo');
  const [infoTextColor, setInfoTextColor] = useState();
  const [more, setMore] = useState(false);

  useEffect(() => {
    if (props.active && !title){
      setInfoTextColor(randomColorInfo[parseInt(Math.random() * 4)]);
      extendGameList()
    }
  }, [props.active])
  
  useEffect(()=>{
    if (props.active && title){
      props.setTitle(title)
    }
  },[props.active,title])

  const extendGameList = ()=>{
    Dialog.loading()
    const data = {
      genre_id:props.query.id,
      genre_type:props.query.type,
      pagination:{
        page:1,
        count:1000
      }
    }
    general.axios.post('getExtendGameList',data)
    .finally(()=>{
      Dialog.close()
    })
    .then(res=>{
      let {status,data} = res.data
      if (!status.succeed) {
        Dialog.error(status.error_desc);
        return;
      }
      setList(data.game_list)
      setTitle(data.title)
      setMore(data.paginated.more);
    })
  }

  return (
    <div className="extend-game-index">
      <div className="extend-game-content">
        {list.map((game,index)=>{
          return <Link to={'/game?id='+game.game_id} className="entity" key={index}>
                  <div className="icon">
                    <Image src={game.game_image.thumb}/>
                    {
                      game?.lablePosition == 2 && game.top_lable != '' ?
                      <div className="iconlable jx" style={{backgroundImage: 'linear-gradient('+game?.lableColor.t+', '+game?.lableColor.b+')'}}>
                        {game.top_lable}
                      </div>
                      : null
                    }
                  </div>
                  <div className="text">
                    <div className="name">
                      <div className={" " + (game.nameRemark ? " name-new" : "")}>
                        {game?.lablePosition == 1 && game.top_lable != '' ? <div className="span">{game.top_lable}</div> : null }
                        {game.game_name}
                      </div>
                    </div>
                    <GameInfo>{game}</GameInfo>
                    <GameTags game={game}></GameTags>
                    {/* {game.discount < 1 ? <div className="discount" ><span>{game.discount * 10}</span>折</div> : null} */}
                  </div>
                  <FreeEdition>{game}</FreeEdition>
                  {index < 3 ? <div className="idx">
                    <img className="index-icon" src={"resources/index/new-" + (index < 3 ? index + 1 : 'more') + ".png"} alt="" />
                    {index > 2 ? <div style={{left:(index < 9 ? '8px' : '3px')}} className="index-text">{index+1}</div> : null}
                  </div> : null}
                </Link>
        })}
        {list.length > 6 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
      </div>
    </div>
  )
}
